export default "__VITE_ASSET__DCbdIk9d__"